import React from "react";
import TableContainer from "./TableContainer";
import PropTypes from "prop-types";

/**
 * Componente React que representa uma tabela de dados
 */
function CommonDataTable({
  colunas,
  linhas,
  botoes = null,
  filtro = true,
  pagination = true,
  footer = null,
  linhaFooter = null,
  ...props
}) {
  return (
    <TableContainer
      columns={colunas}
      data={linhas}
      buttons={botoes}
      isGlobalFilter={filtro}
      isAddOptions={false}
      pagination={pagination}
      customPageSize={10}
      footer={footer}
      linhaFooter={linhaFooter}
      className="custom-header-css"
      {...props}
    />
  );
}

CommonDataTable.propTypes = {
  colunas: PropTypes.arrayOf(PropTypes.object).isRequired,
  linhas: PropTypes.object.isRequired,
  botoes: PropTypes.node,
  filtro: PropTypes.bool,
  pagination: PropTypes.bool,
  footer: PropTypes.arrayOf(PropTypes.object),
  linhaFooter: PropTypes.object,
};

export default CommonDataTable;
